// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import AuditSummaryCriteriaFooter from './criteria-footer';
import AuditSummaryInputCriteria from './input-criteria';
import Criteria from '../../state/criteria';
import DealerHierarchyTerritory from '@deere/cps-it.warranty-model-factory/lib/dealer-hierarchy-territory';

const AuditSummaryReportCriteria = props =>
    <div className='audit-summary-report-criteria'>
        <div className='audit-summary-criteria'>
            <AuditSummaryInputCriteria
                allowedTerritories={props.allowedTerritories}
                criteria={props.criteria}
                handleFiscalYearSelect={props.handleFiscalYearSelect}
                handleSelectAllTerritories={props.handleSelectAllTerritories}
                handleTerritorySelect={props.handleTerritorySelect}
            />
        </div>
        <AuditSummaryCriteriaFooter
            canExport={props.canExport}
            canRunReport={props.canRunReport}
            handleCriteriaReset={props.handleCriteriaReset}
            onDownloadToExcel={props.onExportToCsv}
            onRunReport={props.onCreateAuditSummaryReport}
        />
    </div>;

AuditSummaryReportCriteria.displayName = 'AuditSummaryReportCriteria';
AuditSummaryReportCriteria.propTypes = {
    allowedTerritories: PropTypes.arrayOf(PropTypes.instanceOf(DealerHierarchyTerritory)).isRequired,
    canExport: PropTypes.bool.isRequired,
    canRunReport: PropTypes.bool.isRequired,
    criteria: PropTypes.instanceOf(Criteria).isRequired,
    handleCriteriaReset: PropTypes.func.isRequired,
    handleFiscalYearSelect: PropTypes.func.isRequired,
    handleSelectAllTerritories: PropTypes.func.isRequired,
    handleTerritorySelect: PropTypes.func.isRequired,
    onCreateAuditSummaryReport: PropTypes.func.isRequired,
    onExportToCsv: PropTypes.func.isRequired
};

export default AuditSummaryReportCriteria;



// WEBPACK FOOTER //
// ./src/reports/audit-summary/components/audit-summary-report-criteria/index.js